import { Dispatch } from '../context/useNewRoleContext';
import { Permission } from 'entities/user';

export const updateRolePermissionAction = (
  updatedPermissionName: string,
  updatedPermissionValue: boolean,
  previousPermissions: { [key in Permission]: boolean },
  dispatch: Dispatch,
) => {
  const permissions: { [key in Permission]: boolean } = {
    ...previousPermissions,
    [updatedPermissionName]: updatedPermissionValue,
  };

  dispatch({ type: 'UPDATE_ROLE_PERMISSIONS', payload: { permissions } });
};
